import { createApp } from 'vue'

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import VueTheMask from 'vue-the-mask'
import Vue3Toasity from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Vue3Lottie from 'vue3-lottie'


import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

const vuetify = createVuetify({
  components,
  directives,
})

createApp(App).use(store).use(router).use(vuetify).use(VueTheMask).use(Vue3Toasity).use(Vue3Lottie).mount('#app')